import { Card } from '@veneer/core';
import tokens from '@veneer/tokens';
import styled from 'styled-components';

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
`;

export const SubscriptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${tokens.layout.size4};
`;

export const Section = styled(Card)`
  display: flex;
  flex-direction: column;
  max-width: 1140px;
  gap: ${tokens.layout.size2};

  && {
    border-radius: ${tokens.layout.size4};
    padding: ${tokens.layout.size4};
  }
`;

export const SectionCard = styled(Section)`
  gap: ${tokens.layout.size4};
  font-size: ${tokens.typography.size1};
`;

export const SomethingElseSection = styled(Card)`
  display: flex;
  flex-direction: column;
  padding: ${tokens.layout.size4};
  max-width: 1140px;
  gap: ${tokens.layout.size8};
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: flex-start;

  p,
  a {
    font-size: ${tokens.typography.size1};
  }

  @media screen and (max-width: ${tokens.layout.xsMax}) {
    display: flex;
    flex-direction: column;
    gap: ${tokens.layout.size2};
  }
`;

export const Label = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${tokens.color.gray6};
  font-size: ${tokens.typography.size1};
`;

export const Link = styled.a`
  width: max-content;
  display: flex;
  align-items: center;
  color: #024ad8 !important;
  border-radius: ${tokens.layout.size1};
  outline: none;
  box-shadow: none;
  transition: none;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  &:focus-visible {
    outline: #001cb0 solid 2px;
    outline-offset: 2px;
  }
`;

export const RowIcon = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.layout.size2};
  padding: 6px 12px 6px 0px;

  & > span {
    width: 100%;
  }
`;

export const DeviceImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 280px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;
